import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_PEM_SUMMARY_COST_DATA_REQUEST,
  FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST,
  FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST
} from '../../actions/actionTypes';
import {
  setPEMSummaryCostData,
  fetchPEMSummaryCostDataError,
  setPEMSummaryTurnaroundData,
  fetchPEMSummaryTurnaroundDataError,
  setPEMSummaryServiceQualityData,
  fetchPEMSummaryServiceQualityDataError
} from '../../actions/PEM/PEMSummaryActions';
import {
  getPEMSummaryCostData,
  getPEMSummaryTurnaroundData,
  getPEMSummaryServiceQualityData
} from '@src/middleware/services/PEM/PEMSummary.service';

export function* fetchPEMSummaryCostData(action: any) {
  try {
    const response = yield call(getPEMSummaryCostData, action.payload);
    if (response) {
      yield put(setPEMSummaryCostData(response));
    }
  } catch (error) {
    console.error('Saga: Error in fetchPEMSummaryCostData:', error);
    yield put(fetchPEMSummaryCostDataError(error));
  }
}

export function* fetchPEMSummaryTurnaroundData(action: any) {
  try {
    const response = yield call(getPEMSummaryTurnaroundData, action.payload);
    if (response) {
      yield put(setPEMSummaryTurnaroundData(response));
    }
  } catch (error) {
    console.error('Saga: Error in fetchPEMSummaryTurnaroundData:', error);
    yield put(fetchPEMSummaryTurnaroundDataError(error));
  }
}

export function* fetchPEMSummaryServiceQualityData(action: any) {
  try {
    const response = yield call(getPEMSummaryServiceQualityData, action.payload);
    if (response) {
      yield put(setPEMSummaryServiceQualityData(response));
    }
  } catch (error) {
    console.error('Saga: Error in fetchPEMSummaryServiceQualityData:', error);
    yield put(fetchPEMSummaryServiceQualityDataError(error));
  }
}

export function* pemSummarySaga() {
  yield takeLatest(FETCH_PEM_SUMMARY_COST_DATA_REQUEST, fetchPEMSummaryCostData);
  yield takeLatest(FETCH_PEM_SUMMARY_TURNAROUND_DATA_REQUEST, fetchPEMSummaryTurnaroundData);
  yield takeLatest(FETCH_PEM_SUMMARY_SERVICE_QUALITY_DATA_REQUEST, fetchPEMSummaryServiceQualityData);
}

export default [pemSummarySaga];